// Browser Notification + Audio utility for admin alerts

/**
 * Request browser notification permission.
 * Returns 'granted' | 'denied' | 'default'
 */
export async function requestNotificationPermission() {
  if (!('Notification' in window)) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  const result = await Notification.requestPermission();
  return result;
}

/**
 * Current permission state: 'granted' | 'denied' | 'default' | 'unsupported'
 */
export function getNotificationPermission() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}

/**
 * Send a browser notification if permission is granted.
 */
export function sendBrowserNotification(title, body, icon = '/favicon.ico') {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  try {
    new Notification(title, { body, icon });
  } catch (e) {
    // Ignore errors (e.g. service worker required in some browsers)
  }
}

/**
 * Play a short beep via Web Audio API.
 * @param {number} frequency - Hz (default 880)
 * @param {number} duration  - seconds (default 0.3)
 */
export function playBeep(frequency = 880, duration = 0.3) {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = frequency;
    osc.type = 'sine';
    gain.gain.setValueAtTime(0.3, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch (e) {
    // Ignore audio errors
  }
}

/**
 * Play a two-tone alert beep (more distinct than a single tone).
 */
export function playAlertBeep() {
  playBeep(880, 0.15);
  setTimeout(() => playBeep(1100, 0.2), 180);
}
